import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(
  <path d="M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z" />,
  'SignalCellularNull',
);
